<div>
    <div class="d-flex justify-content-center">
        <img class="login-logo" src="/img/LOGOpimeo.png" />
    </div>
    <div class="text-center">
        <h3>Thank you for your time!</h3>
        <h4>Please close this page.</h4>
    </div>
</div>
